import React, { useState } from 'react';
import { useAtomValue } from 'jotai';
import IconButton from '@mui/material/IconButton';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import MenuIcon from '@mui/icons-material/Menu';
import SearchIcon from '@mui/icons-material/Search';
import NotificationsIcon from '@mui/icons-material/Notifications';
import SettingsIcon from '@mui/icons-material/Settings';
import Badge from '@mui/material/Badge';
import Avatar from '@mui/material/Avatar';
import Menu from '@mui/material/Menu';
import ListItemIcon from '@mui/material/ListItemIcon';
import MenuItem from '@mui/material/MenuItem';
import Typography from '@mui/material/Typography';
import lzSAuthUserAtom from '@lz-atoms/Auth/user';
import { LzTFunctionSimple } from '@lz/typings/types';
import { LzTNavItem, LzTNavItems } from '../../layout/Navigation/types';

import './NavBar.scss';

export interface LzPModernWithLeftNavTemplateNavBar {
  navOpen: boolean;
  onNavToggle: LzTFunctionSimple;
  onSettingsPangeToggle: LzTFunctionSimple;
  accountMenuItems?: LzTNavItems;
  onAccountMenuItemClick?: (
    item: LzTNavItem,
    event: React.MouseEvent<HTMLElement, MouseEvent>
  ) => void;
}

const LzXModernWithLeftNavTemplateNavBar = (props: LzPModernWithLeftNavTemplateNavBar) => {
  const [avatarEl, setAvatarEl] = useState<Element | null>(null);

  const authUserState = useAtomValue(lzSAuthUserAtom);

  return (
    <div className='lz-navbar'>
      <div className='lz-navbar-section'>
        <IconButton onClick={props.onNavToggle}>
          {props.navOpen ? <ArrowBackIcon /> : <MenuIcon />}
        </IconButton>
      </div>
      <div className='lz-navbar-section'>
        <IconButton>
          <SearchIcon />
        </IconButton>
        <IconButton>
          <Badge badgeContent={3} color='secondary' showZero>
            <NotificationsIcon />
          </Badge>
        </IconButton>
      </div>
      {authUserState && (
        <div className='lz-navbar-section'>
          <IconButton onClick={props.onSettingsPangeToggle}>
            <SettingsIcon />
          </IconButton>
          <IconButton onClick={(ev) => setAvatarEl(ev.currentTarget)}>
            <Avatar
              alt={authUserState.name}
              src={
                authUserState.avatar_media ? authUserState.avatar_media_src : undefined
              }
            >
              {authUserState.avatar_initials}
            </Avatar>
          </IconButton>
          {props.accountMenuItems && (
            <Menu
              keepMounted
              className='lz-avatar-menu'
              anchorEl={avatarEl}
              open={!!avatarEl}
              onClose={() => setAvatarEl(null)}
            >
              {props.accountMenuItems.map((item, dex) => (
                <MenuItem
                  key={'lnk-' + dex}
                  onClick={(event) => {
                    if (props.onAccountMenuItemClick) {
                      props.onAccountMenuItemClick(item, event);
                    }
                  }}
                >
                  <ListItemIcon>{item.icon}</ListItemIcon>
                  <Typography>{item.title}</Typography>
                </MenuItem>
              ))}
            </Menu>
          )}
        </div>
      )}
    </div>
  );
};

export default LzXModernWithLeftNavTemplateNavBar;
